import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  uploads: [],
  selectedUpload: null
};


export const uploadsSlice = createSlice({
  name: 'uploads',
  initialState,
  
  reducers: {
    setUploads: (state, action) => {
      state.uploads = action.payload;
    },
    addUpload: (state, action) => {
        state.uploads.unshift(action.payload);
    },
    renameUpload: (state, action) => {
      const upload = state.uploads.find((u) => u && u.id === action.payload.id);
      if (upload) upload.title = action.payload.title;
    }
  }
});

export const {setUploads, addUpload, renameUpload} = uploadsSlice.actions;

export const selectUploads = (state) => state.uploads.uploads;

export default uploadsSlice.reducer;
